<template>
  <b-form-group
    label="Slug"
    label-for="slug"
  >
    <validation-provider
      #default="{ errors }"
      name="Slug"
      rules="required"
    >
      <b-form-input
        id="slug"
        v-model="dataItem.slug"
        placeholder="Slug"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'Slug',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['projects/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
